module.exports = __webpack_public_path__ + "static/media/cimg3.50de3650.jpg";